// extracted by mini-css-extract-plugin
export default {"container":"style_container__2oqkp","logoSection":"style_logoSection__NZ4lb","title":"style_title__AiHcC","subName":"style_subName__8wtSj"};